/* Deferred third parties — chat and loyalty widgets.
 *
 * Neither widget is needed to render the page or to buy, so instead of
 * loading them on the critical path they are injected after the first user
 * interaction (scroll, tap, key, pointer) or, as a safety net, once the page
 * has been idle for a few seconds. Configuration comes from data attributes
 * on the <script> tag in layout/theme.liquid.
 */
(function () {
  'use strict';
  var cfg = (document.currentScript && document.currentScript.dataset) || {};
  var done = {};

  function inject(src, onload) {
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    if (onload) s.onload = onload;
    document.head.appendChild(s);
  }

  function loadChat() {
    if (done.chat || !cfg.chatToken) return;
    done.chat = true;
    inject(cfg.chatCdn + '/js/sdk.js', function () {
      if (window.chatwootSDK) {
        window.chatwootSDK.run({ websiteToken: cfg.chatToken, baseUrl: cfg.chatBase });
      }
    });
  }

  function loadSmile() {
    if (done.smile || cfg.smile !== 'true') return;
    done.smile = true;
    // If the Smile app embed is switched back on in the theme editor, it
    // loads the same script itself; do not load it twice.
    if (document.querySelector('script[src*="js.smile.io"]')) return;
    // smile-shopify.js looks for the init element the app embed used to
    // render (a div carrying the channel key); without it the launcher never
    // appears. Recreate it before the script loads.
    if (cfg.smileChannel && !document.querySelector('.smile-shopify-init')) {
      var init = document.createElement('div');
      init.className = 'smile-shopify-init';
      init.setAttribute('data-channel-key', cfg.smileChannel);
      document.body.appendChild(init);
    }
    inject('https://js.smile.io/v1/smile-shopify.js?shop=' + encodeURIComponent(cfg.shop || ''));
  }

  function loadAll() {
    loadChat();
    loadSmile();
  }

  ['scroll', 'pointerdown', 'touchstart', 'keydown', 'mousemove'].forEach(function (evt) {
    window.addEventListener(evt, loadAll, { passive: true, once: true });
  });

  // Anything that opens the rewards panel needs Smile straight away.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[href*="smile"], [data-smile], .smile-launcher');
    if (t) loadSmile();
  }, true);

  // Safety net: returning customers who do not touch the page still get
  // their open conversation or points balance after the page settles.
  var idleMs = parseInt(cfg.idleMs || '8000', 10);
  function afterLoad() { window.setTimeout(loadAll, idleMs); }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad);
})();
